export default __webpack_public_path__ + "static/media/img-10.0886a85b.jpg";